<template>
    <div name="sensitive">
        <h2>[민감정보의 수집 및 이용동의]</h2>
        <span>솔닥 주식회사(이하 “회사”) 는 솔닥 서비스 제공과 관련하여 개인정보보호법 제23조 제1항 제1호에 근거하여 아래와 같이 이용자의 민감정보를 수집 및 이용하고자 합니다.<br></span><br>
        <table class="table" border="1">
            <thead>
                <th style="width: 10%;">
                    구분
                </th>
                <th style="width: 30%;">
                    수집 및 이용 목적
                </th>
                <th style="width: 30%;">
                    수집 항목
                </th>
                <th style="width: 30%;">
                    보유 기간
                </th>
            </thead>
            <tbody>
                <tr>
                    <td>프로필 등록</td>
                    <td>비대면진료 예약, 고객별 당뇨병 소모성재료 공단 지원 금액 계산 및 요양비 위임 청구 서비스 제공</td>
                    <td>기저질환, 투약정보</td>
                    <td>서비스 회원 탈퇴 및 이용계약 종료 시<br>(단, 관련법령에 따라 별도 보관되는 정보는 예외)</td>
                </tr>
            </tbody>
            
        </table>
        <span><br>※ 이용자는 민감정보의 수집 및 이용 동의를 거부할 권리가 있습니다. 다만 동의 거부 시 해당 서비스를 이용하실 수 없습니다</span>
    </div>
</template>

<script>
export default {
    name: 'sensitive'
}
</script>

<style scoped>
    th {
      background-color: #f4f4f4;
      font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/barocare/Sensitive.vue